export default __webpack_public_path__ + "static/header-background-edcdfb48055f8d96f3065fa624c221d6.jpg";